'use client';

import Link from 'next/link';
import { Logo } from './Logo';

const links = [
  { label: 'About', href: '/about' },
  { label: 'Privacy', href: '/privacy' },
  { label: 'Terms', href: '/terms' },
  { label: 'TCPA Policy', href: '/tcpa' },
  { label: 'Learn', href: '/learn' },
  { label: 'Contact', href: 'mailto:support@trustboxai.com' },
] as const;

export function LandingFooter() {
  return (
    <footer style={{ background: '#0A1F12' }}>
      <div className="mx-auto max-w-5xl px-6 py-16 text-center">
        {/* Decorative waveform divider */}
        <div
          className="mx-auto mb-10 flex items-center justify-center gap-[3px]"
          role="separator"
          aria-hidden="true"
        >
          {[0.4, 0.7, 1, 0.7, 0.4].map((scale, i) => (
            <div
              key={`footer-divider-${i}`}
              className="rounded-full"
              style={{
                width: 2,
                height: 10 * scale,
                backgroundColor: 'var(--text-muted)',
                opacity: 0.3,
              }}
            />
          ))}
        </div>

        {/* Logo + tagline */}
        <div className="mb-8 flex flex-col items-center gap-3">
          <div className="flex items-center gap-2">
            <Logo size={24} variant="dark" />
            <span
              className="text-xl font-bold tracking-tight"
              style={{ fontFamily: 'var(--font-display)', color: 'var(--text-on-dark)' }}
            >
              TrustboxAI
            </span>
          </div>
          <p
            className="text-sm"
            style={{ fontFamily: 'var(--font-body)', color: 'var(--text-muted)' }}
          >
            Making families scam-proof, one call at a time
          </p>
        </div>

        {/* Links row */}
        <nav className="mb-10 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {links.map(({ label, href }) => (
            <Link
              key={label}
              href={href}
              className="text-sm transition-colors"
              style={
                {
                  fontFamily: 'var(--font-body)',
                  color: 'var(--text-muted)',
                  '--hover-color': 'var(--text-on-dark)',
                } as React.CSSProperties
              }
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--text-on-dark)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--text-muted)';
              }}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Social */}
        <div className="flex items-center justify-center gap-4 mt-4 mb-6">
          <a
            href="https://x.com/trustboxai"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--text-muted)' }}
            className="hover:opacity-80 transition-opacity"
            onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--text-on-dark)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-muted)'; }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
          </a>
        </div>

        {/* Copyright */}
        <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
          &copy; 2026 TrustboxAI. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
